import { createContext, useCallback, useContext, useState } from "react";
import { toast } from "sonner";
import { Sparkles, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { usePlatform } from "@/lib/platform";
import { AuthModal } from "@/components/auth/AuthModal";

export const RETURN_KEY = "aetryx_return";
export const NUDGE_COPY = "Save your progress and unlock all AETRYX Originals —";
const GuestContext = createContext(null);

const Nudge = ({ id, onSignUp }) => (
  <div data-testid="guest-nudge" className="flex w-[340px] items-start gap-3 rounded-2xl border border-[#D4AF37]/40 bg-[#0B0B0D]/95 p-4 text-white shadow-[0_20px_60px_rgba(0,0,0,0.7)] backdrop-blur-xl">
    <Sparkles className="mt-0.5 h-5 w-5 flex-none text-[#FFD86A]" />
    <p className="flex-1 text-sm text-white/80">{NUDGE_COPY} <button data-testid="guest-nudge-signup" onClick={() => { toast.dismiss(id); onSignUp(); }} className="font-bold text-[#FFD86A] hover:underline">Sign up free</button></p>
    <button data-testid="guest-nudge-dismiss" aria-label="Dismiss" onClick={() => toast.dismiss(id)} className="text-white/40 hover:text-white"><X className="h-4 w-4" /></button>
  </div>
);

export function GuestProvider({ children }) {
  const { user } = useAuth();
  const platform = usePlatform();
  const guestOn = platform.name ? platform.guest_browsing !== false : undefined;
  const isGuest = user === false && guestOn === true;
  const [auth, setAuth] = useState(null);

  const openAuth = useCallback((opts = {}) => setAuth({ mode: "login", reason: "locked", ...opts }), []);
  const nudge = useCallback((trigger) => {
    const key = `aetryx_nudge_${trigger}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    toast.custom((id) => <Nudge id={id} onSignUp={() => openAuth({ mode: "register", reason: "nudge" })} />, { id: key, duration: 15000 });
  }, [openAuth]);

  return (
    <GuestContext.Provider value={{ isGuest, guestOn, openAuth, nudge }}>
      {children}
      <AuthModal state={auth} onClose={() => setAuth(null)} />
    </GuestContext.Provider>
  );
}

export const useGuest = () => useContext(GuestContext);
